import VisibilityOffRounded from '@mui/icons-material/VisibilityOffRounded';
import VisibilityRounded from '@mui/icons-material/VisibilityRounded';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { useState, type ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

/** Password input with a show/hide toggle, wired to react-hook-form's `register()`. */
export function PasswordField({
  label,
  autoComplete,
  registration,
  error,
  helperText,
  startIcon,
  size = 'medium',
}: {
  label: string;
  autoComplete: 'current-password' | 'new-password';
  registration: UseFormRegisterReturn;
  error?: string;
  helperText?: ReactNode;
  startIcon?: ReactNode;
  size?: 'small' | 'medium';
}) {
  const [show, setShow] = useState(false);
  return (
    <TextField
      size={size}
      label={label}
      type={show ? 'text' : 'password'}
      autoComplete={autoComplete}
      {...registration}
      error={Boolean(error)}
      helperText={error ?? helperText}
      slotProps={{
        input: {
          startAdornment: startIcon,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={() => setShow((s) => !s)}
                aria-label={show ? `Hide ${label.toLowerCase()}` : `Show ${label.toLowerCase()}`}
                edge="end"
              >
                {show ? (
                  <VisibilityOffRounded fontSize="small" />
                ) : (
                  <VisibilityRounded fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
